/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Wizard_ErrorInputs */



/**
* | output |
* | --- |
* | "The space was created, but linking it to the projects failed. You can retry from the space settings." |
*
* @param {Linked_Projects_Wizard_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_wizard_error = /** @type {((inputs?: Linked_Projects_Wizard_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Wizard_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Space wurde erstellt, aber die Verknüpfung mit den Projekten ist fehlgeschlagen. Du kannst es in den Space-Einstellungen erneut versuchen.")
	return /** @type {LocalizedString} */ ("The space was created, but linking it to the projects failed. You can retry from the space settings.")
});